import { NavigateFunction } from "react-router-dom";
import http from "../../utils/http";
import { AppDispatch } from "../../Redux/store";
import { resetState } from "../../Redux/actions/resetAction";

export async function logoutParticipantToStudyLanding(
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) {
  const studySlug = localStorage.getItem("study-slug") || "";
  try {
    await http.post("/participant/auth/logout");
  } catch {
    // Still clear session and redirect if logout fails
  } finally {
    localStorage.clear();
    dispatch(resetState());
    navigate(studySlug ? `/study/${studySlug}` : "/auth/participant/login", {
      replace: true,
    });
  }
}
